import { createSlice } from '@reduxjs/toolkit';
import { Verification } from './models';
// import { addThunkCases } from './thunks';

const initialState: Verification = {
  status: 'idle',
  message: null,
  verification: {
    id: '',
    phone: '',
    title: '',
    firstName: '',
    lastName: '',
    email: '',
    dateOfBirth: '',
    address: {
      addressLine1: '',
      addressLine2: '',
      town: '',
      province: '',
      county: '',
      countryIso: '',
      postcode: '',
      country: '',
    },
    countryISO: '',
    idType: '',
    governmentIdBase64: '',
    selfieBase64: '',
    termsAccepted: false,
  },
};

// Redux Slice
export const slice = createSlice({
  name: 'verification',
  initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    clearStatus: state => {
      state.status = 'idle';
      state.message = null;
    },
    setVerification: (state, action) => {
      state.verification = action.payload;
    },
  },
  // extraReducers: addThunkCases,
});

// redux selectors
export const selectVerification = (state: { verification: Verification }) =>
  state.verification;

// auto-generated redux actions
export const { clearStatus, setVerification } = slice.actions;
